import { on } from 'ivent';
import { debounce } from 'throttle-debounce';
import round from './utils/round';

const mapSection = new Map();
let windowWidth = window.innerWidth;

function updateBadgeOffset(badge, badgeSpan, firstElement, lastElement) {
	if (windowWidth < 600) return;

	const spanHeight = badgeSpan.getBoundingClientRect().height * 0.5;

	const firstContent =
		firstElement.querySelector('.card-content') || firstElement;
	const offsetTop =
		firstContent.offsetTop +
		firstContent.getBoundingClientRect().height * 0.5 -
		spanHeight;
	badge.style.setProperty(
		'--section--badge--offset-top',
		`${Math.max(0, round(offsetTop))}px`,
	);

	if (!lastElement) return;
	const lastContent = lastElement.querySelector('.card-content') || lastElement;
	const offsetBottom =
		lastContent.getBoundingClientRect().height * 0.5 - spanHeight;
	badge.style.setProperty(
		'--section--badge--offset-bottom',
		`${Math.max(0, round(offsetBottom))}px`,
	);
}

function createListByYear(
	sectionList,
	children,
	mapByYear,
	hasPrepend = false,
) {
	const insertFn = hasPrepend ? 'prepend' : 'append';
	hasPrepend && children.reverse();

	// Create list by year.
	children.forEach((item) => {
		const year = item.getAttribute('data-year');
		const cloneItem = item.cloneNode(true);

		if (mapByYear.has(year)) {
			// Insert list.
			mapByYear.get(year).listByYear[insertFn](cloneItem);
			mapByYear.get(year).list.push(cloneItem);
		} else {
			// Create list.
			const listByYear = document.createElement('div');
			listByYear.classList.add('section-list-by-year');
			listByYear.setAttribute('data-section-year', year);
			listByYear[insertFn](cloneItem);

			// Create badge.
			const badge = document.createElement('div');
			const badgeSpan = document.createElement('span');
			badge.classList.add('section-list-badge');
			badgeSpan.textContent = year;
			badge[insertFn](badgeSpan);
			listByYear.prepend(badge);

			// Insert list.
			sectionList[insertFn](listByYear);

			mapByYear.set(year, { list: [cloneItem], listByYear, badge, badgeSpan });
		}
	});

	// Update badge.
	mapByYear.forEach(({ badge, badgeSpan, list }) => {
		const firstElement = list[0];
		updateBadgeOffset(badge, badgeSpan, firstElement, list[list.length - 1]);

		// Update when load image.
		const firstImage = firstElement.querySelector('img');
		if (firstImage && !firstImage.complete) {
			firstImage.addEventListener('load', () =>
				updateBadgeOffset(badge, badgeSpan, firstElement),
			);
		}
	});
}

document.querySelectorAll('.section-list-has-badge').forEach((sectionList) => {
	// Set map by year.
	const mapByYear = new Map();
	const children = Array.from(sectionList.children);
	sectionList.innerHTML = '';

	createListByYear(sectionList, children, mapByYear);

	mapSection.set(sectionList, mapByYear);
});

// Update badge offset when window resize.
on(
	window,
	'resize',
	debounce(100, () => {
		windowWidth = window.innerWidth;
		if (windowWidth < 600) return;

		mapSection.forEach((mapByYear) => {
			mapByYear.forEach(({ badge, badgeSpan, list }) => {
				updateBadgeOffset(badge, badgeSpan, list[0], list[list.length - 1]);
			});
		});
	}),
);

on(document, 'pvs.pagination.render', ({ data }) => {
	const { insertTo } = data;
	data.insertCallback = () => {
		if (!insertTo.classList.contains('section-list-has-badge')) return;

		const mapByYear = mapSection.get(insertTo);

		createListByYear(
			insertTo,
			Array.from(data.insertFrom.children),
			mapByYear,
			data.prependSelector,
		);

		mapSection.set(insertTo, mapByYear);
	};
});
